export interface CanvasLoadingPolicyInput {
  readonly isLoadingAccess: boolean;
  readonly isSynced: boolean;
  readonly isInitialLoading: boolean;
  readonly nodeCount: number;
  readonly orgFirstFitPending: boolean;
  readonly isProjectionChart: boolean;
  readonly isProjectionLoading: boolean;
  readonly hasProjectionData: boolean;
  readonly projectionError: unknown;
}

export interface CanvasLoadingPolicy {
  readonly showCanvasLoadingOverlay: boolean;
  readonly projectionLoadFailed: boolean;
}

/** Completion generations survive a fast pending -> clear transition. */
export function orgViewportFitCompletedSince(
  baselineCompletionCount: number,
  currentCompletionCount: number,
): boolean {
  return currentCompletionCount > baselineCompletionCount;
}

/** Resolves every data owner that must be ready before the canvas is revealed. */
export function resolveCanvasLoadingPolicy(
  input: CanvasLoadingPolicyInput,
): CanvasLoadingPolicy {
  const projectionLoadFailed = input.isProjectionChart
    && input.projectionError != null
    && !input.hasProjectionData;
  const canvasSubstrateLoading = input.isLoadingAccess
    || !input.isSynced
    || (input.isInitialLoading && input.nodeCount > 0)
    || (input.orgFirstFitPending && input.nodeCount > 0);
  const projectionLoading = input.isProjectionChart && input.isProjectionLoading;

  return {
    projectionLoadFailed,
    showCanvasLoadingOverlay: !projectionLoadFailed
      && (canvasSubstrateLoading || projectionLoading),
  };
}
